<ng-container [formGroup]="form" *ngIf="fields().length">
  <ng-container *ngFor="let field of fields()" [ngSwitch]="field.properties.type">
    <q9ma-checkbox-wrapper [isPreview]="isPreview">
      <ng-container *ngSwitchCase="'text'">
        <q9-text-field
          [isRequired]="field.required"
          [label]="field.title | decodeHtml"
          [placeholder]="field.placeholder | decodeHtml"
          [formControlName]="field.id"></q9-text-field>
      </ng-container>

      <ng-container *ngSwitchCase="'longtext'">
        <q9-rich-text-field
          [isRequired]="field.required"
          [label]="field.title | decodeHtml"
          [placeholder]="field.placeholder | decodeHtml"
          [formControlName]="field.id"></q9-rich-text-field>
      </ng-container>

      <ng-container *ngSwitchCase="'list'">
        <q9-select
          [isRequired]="field.required"
          [label]="field.title | decodeHtml"
          [formControlName]="field.id">
          <q9-option *ngIf="!field.properties.predefined && !field.required">
            {{ field.placeholder || 'Please select option' | decodeHtml }}
          </q9-option>
          <q9-option *ngFor="let option of field.properties.options" [value]="option._id">
            {{ option.value | decodeHtml }}
          </q9-option>
        </q9-select>
      </ng-container>

      <ng-container *ngSwitchCase="'taglist'">
        <q9-chips-select
          [label]="field.title | decodeHtml"
          [placeholder]="field.placeholder | decodeHtml"
          [isRequired]="field.required"
          [options]="field.properties.tags!"
          [formControlName]="field.id"></q9-chips-select>
      </ng-container>

      <ng-container *ngSwitchCase="'number'">
        <q9-text-field
          type="number"
          [isRequired]="field.required"
          [label]="field.title | decodeHtml"
          [placeholder]="field.placeholder | decodeHtml"
          [formControlName]="field.id"></q9-text-field>
      </ng-container>

      <ng-container *ngSwitchCase="'datetime'">
        <q9-datetime-picker
          [label]="field.title | decodeHtml"
          [placeholder]="field.placeholder | decodeHtml"
          [isRequired]="field.required"
          [formControlName]="field.id"></q9-datetime-picker>
      </ng-container>
    </q9ma-checkbox-wrapper>
  </ng-container>
</ng-container>
